import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider, focusManager } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// NOTE: React.StrictMode intentionally double-invokes effects in dev, which
// clashes with react-leaflet's imperative Map initialisation ("Map container
// is already initialized"). We keep StrictMode disabled here for that reason.

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

// React Query's default only notices the page becoming visible. In the desktop
// app the window is often beside the browser rather than under it, so coming
// back from bidding on the website changed nothing it could see. Window focus
// now counts too. Only queries that opt in to refetchOnWindowFocus react (the
// bid lists, lib/bids.js), and "focused" itself still follows visibility, so
// nothing that polls is paused when the pilot clicks into the sim.
focusManager.setEventListener((handleFocus) => {
  const notify = () => handleFocus();
  window.addEventListener("visibilitychange", notify, false);
  window.addEventListener("focus", notify, false);
  return () => {
    window.removeEventListener("visibilitychange", notify);
    window.removeEventListener("focus", notify);
  };
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <QueryClientProvider client={queryClient}>
    <App />
  </QueryClientProvider>,
);
